import React, { FunctionComponent } from 'react';
import Filters from './Filters';
import SearchContainer from './SearchContainer';
import { isMobile } from 'react-device-detect';
import { FilterType } from '../types';
import { useProjectLibraryContext } from '../contexts/ProjectLibraryContext';

const ProjectLibraryControlContainer: FunctionComponent = () => {
    const projectLibraryContext = useProjectLibraryContext();

    const filterProps = {
        filters: [
            {
                name: FilterType.DATE,
                display_name: 'Date',
            },
            {
                name: FilterType.USER,
                display_name: 'User',
            },
        ],
        appliedFilters: projectLibraryContext.state.appliedFilters,
        setAppliedFilters: projectLibraryContext.setters.setAppliedFilters,
        filterCounts: projectLibraryContext.state.filterCounts,
        sortProps: {
            appliedSortOption: projectLibraryContext.state.appliedSortOption,
            setAppliedSortOption:
                projectLibraryContext.setters.setAppliedSortOption,
        },
    };

    return (
        <>
            <div className="filter-controls">
                <h2>Project Library</h2>
                {!isMobile && <Filters {...filterProps} />}
                <SearchContainer
                    appliedSearchString={
                        projectLibraryContext.state.searchString
                    }
                    setAppliedSearchString={
                        projectLibraryContext.setters.setSearchString
                    }
                />
            </div>
            {isMobile && (
                <div className="filter-controls mobile">
                    <Filters {...filterProps} />
                </div>
            )}
        </>
    );
};

export default ProjectLibraryControlContainer;
